import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodBasicComponent ({handleInnerFormChange,chosenPaymentMethod,stores}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Store"
            labelField="StoreInfo.StoreName"
            list={stores}
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'RazorPayConfiguration.StoreId',
                chosenPaymentMethod?.RazorPayConfiguration
              );
            }}
            optionName='Choose Store'
            type="select"
            value={chosenPaymentMethod?.RazorPayConfiguration?.StoreId}
            valueField="StoreInfo.Id"
        />
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Information"
/>
    
        </>
  )
}